import { useCallback, useEffect, useState } from 'react';
import { getUnreadCount, hasToken } from '../api';

// ============================================================================
// Блок «Уведомления в приложении»: колокольчик со счётчиком непрочитанных.
// Счётчик обновляется раз в минуту, при возврате на вкладку и по событию
// NOTIFICATIONS_CHANGED_EVENT (его шлёт экран уведомлений после прочтения).
// Без веб-сокетов: опрос лёгкого эндпоинта /notifications/unread-count.
// ============================================================================

export const NOTIFICATIONS_CHANGED_EVENT = 'gh:notifications-changed';

export function notifyNotificationsChanged(): void {
  window.dispatchEvent(new Event(NOTIFICATIONS_CHANGED_EVENT));
}

export default function NotificationBell({ onOpen }: { onOpen: () => void }) {
  const [unread, setUnread] = useState(0);

  const refresh = useCallback(() => {
    if (!hasToken()) return;
    getUnreadCount()
      .then(({ data }) => setUnread(data.unread))
      .catch(() => { /* счётчик не критичен — молча пропускаем */ });
  }, []);

  useEffect(() => {
    refresh();
    const timer = window.setInterval(refresh, 60_000);
    const onVisible = () => { if (document.visibilityState === 'visible') refresh(); };
    document.addEventListener('visibilitychange', onVisible);
    window.addEventListener(NOTIFICATIONS_CHANGED_EVENT, refresh);
    return () => {
      window.clearInterval(timer);
      document.removeEventListener('visibilitychange', onVisible);
      window.removeEventListener(NOTIFICATIONS_CHANGED_EVENT, refresh);
    };
  }, [refresh]);

  return (
    <button
      onClick={onOpen}
      aria-label={unread > 0 ? `Уведомления: ${unread} непрочитанных` : 'Уведомления'}
      style={{
        position: 'relative',
        background: 'var(--tg-secondary-bg)',
        border: 'none',
        borderRadius: 10,
        padding: '6px 10px',
        fontSize: 15,
        lineHeight: 1.2,
        cursor: 'pointer',
        fontFamily: 'inherit',
      }}
    >
      🔔
      {unread > 0 && (
        <span
          style={{
            position: 'absolute',
            top: -5,
            right: -5,
            minWidth: 18,
            height: 18,
            padding: '0 4px',
            borderRadius: 9,
            background: '#e5484d',
            color: '#fff',
            fontSize: 11,
            fontWeight: 700,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {unread > 99 ? '99+' : unread}
        </span>
      )}
    </button>
  );
}
